<!--
 @description 服务监控-应用详情页-性能指标tab
 @author xiehan
 @date 2018/11/12
-->
<template>
  <div>
    <el-form ref="chartForm" :model="chartForm" label-width="40px" :inline="true" class="demo-form-inline">
      <el-form-item :label="$t('common.time')" input-width="auto">
        <el-form-item prop="startTime">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="chartForm.startTime" type="datetime">
          </el-date-picker>
        </el-form-item>
        <span v-text="$t('common.to')"></span>
        <el-form-item prop="endTime" style="margin-left: 10px">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="chartForm.endTime" type="datetime">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getKpiMapping" v-g-rac="gRac('appDetailKpi_search')" v-text="$t('common.search')"></el-button>
        </el-form-item>
      </el-form-item>
    </el-form>
    <ob-server-charts :query-parames="item" :index="index" v-for="(item, index) in chartDataList" :key="index + item.startTime + item.endTime"></ob-server-charts>
    <div v-show="this.chartDataList.length === 0" v-text="$t('common.noData')" style="text-align: center"></div>
  </div>
</template>

<script>
  import obServerCharts from '@/components/chart/obServerCharts'
  import rac from '@/plugins/rac-mixin'
  import KpiMappingBiz from '@/logic/systemSetting/kpiMappingBiz'
  import ITDeviceMonitorBiz from '@/logic/intelligentMonitor/ITDeviceMonitorBiz'
  export default {
    mixins: [rac],
    data () {
      return {
        prevApp: '',
        chartForm: {
          startTime: '',
          endTime: ''
        },
        chartDataList: []
      }
    },
    components: {
      obServerCharts
    },
    props: ['app', 'group', 'active'],
    methods: {
      getKpiMapping () {
        KpiMappingBiz.getKpiMap({
          group: this.group,
          appName: this.app,
          siteCode: this.$route.query.siteCode
        }).then(data => {
          let chartDataList = []
          data.map(item => {
            let alarm = !!item.alarm
            chartDataList.push(this.getChartParames(item.kpiKey, item.desc, alarm))
          })
          this.chartDataList = [...chartDataList]
        })
      },
      getChartParames (kpiKey, desc, alarm) {
        return {
          group: this.group,
          appName: this.app,
          siteCode: this.$route.query.siteCode,
          kpiKey: kpiKey,
          startTime: this.chartForm.startTime,
          endTime: this.chartForm.endTime ? this.chartForm.endTime : new Date().getTime(),
          desc,
          alarm
        }
      },
      getChartData (kpiKey, desc, alarm) {
        return new Promise((resolve, reject) => {
          ITDeviceMonitorBiz.getChartData({
            group: this.group,
            appName: this.app,
            kpiKey: kpiKey,
            startTime: this.chartForm.startTime,
            endTime: this.chartForm.endTime || new Date().getTime(),
            siteCode: this.$route.query.siteCode
          }).then(data => {
            resolve({
              title: desc,
              data: data,
              alarm: alarm,
              kpiInfo: {
                appGroup: this.group,
                appName: this.app,
                kpiKey: kpiKey,
                siteCode: this.$route.query.siteCode
              }
            })
          }).catch(err => {
            reject(err)
          })
        })
      },
      drawChart (dataList) {
        const list = []
        dataList.map((item, index) => {
          const chartData = {
            title: item.title,
            kpiInfo: item.kpiInfo,
            chartId: `chartGroups-serverDP-${item.title}${index}`,
            chartData: {
              rows: item.data ? item.data : [],
              columns: ['eventTime', 'value'],
              alarm: item.alarm,
              formatMap: {
                eventTime: 'TIME'
              },
              labelMap: {
                value: item.title
              }
            }
          }
          list.push(chartData)
        })
        this.chartDataList = list
      }
    },
    watch: {
      active () {
        if (this.active === 'performance' && this.prevApp !== this.app) {
          this.chartForm.startTime = new Date(new Date().toLocaleDateString()).getTime()
          this.chartForm.endTime = ''
          this.getKpiMapping()
          this.prevApp = this.app
        }
      }
    }
  }
</script>

<style>

</style>